import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

// 사용자: 입고지 배송기사 정보 조회
export interface WarehouseOption {
    warehouse_no: number;
    name: string;
    port_name: string;
    post: string;
    address1: string;
    address2: string;
}

export interface DriverInfoResult {
    port_name: string;
    warehouse_name: string;
    work_date: string;
    driver_name: string;
    phone: string;
    car_no: string;
}

// 입고지명 셀렉트 옵션
export const useGetDriverInfoWarehouses = (): UseQueryResult<WarehouseOption[], Error> => {
    return useQuery({
        queryKey: ["useGetDriverInfoWarehouses"],
        queryFn: async () => {
            const response = await axiosInstance.get(enum_api_uri.get_driver_info_warehouses);
            return response.data.data;
        },
    });
};

// 검색: 입고지명 + 기간(시작일~종료일) 조건에 해당하는 담당기사 목록 조회 (페이지네이션)
export interface DriverInfoSearchParams {
    warehouse_no: number | string;
    work_date: string;
    page: number;
    limit: number | string;
}

export interface DriverInfoSearchResponse {
    limit: number;
    current_page: number;
    last_page: number;
    total_count: number;
    data_list: DriverInfoResult[];
}

export const useGetDriverInfoSearch = (
    params: DriverInfoSearchParams | null,
): UseQueryResult<DriverInfoSearchResponse, Error> => {
    return useQuery({
        queryKey: ["useGetDriverInfoSearch", params],
        queryFn: async () => {
            const response = await axiosInstance.get(enum_api_uri.get_driver_info_search, { params });
            return response.data.data;
        },
        enabled: !!params,
    });
};
